import { buildParams, http } from "./http"

export const getProductAdds = (pid: number) => 
  http.get<any, any>(`/loyalty/store/adds/${pid}`)

export const getProductVars = (pid: number) => 
  http.get<any, any>(`/loyalty/store/vars/${pid}`)

export const createProductAdd = (pid: number, dto: any) => 
  http.post<any, any>(`/loyalty/store/adds/${pid}`, dto)

export const createProductVar = (pid: number, dto: any) => 
  http.post<any, any>(`/loyalty/store/vars/${pid}`, dto)

export const updateProductAdd = (pid: number, id: number, dto: any) => 
  http.put<any, any>(`/loyalty/store/adds/${pid}/${id}`, dto)

export const updateProductVar = (pid: number, id: number, dto: any) => 
  http.put<any, any>(`/loyalty/store/vars/${pid}/${id}`, dto)

export const deleteProductAdd = (pid: number, id: number) => 
  http.delete<any, any>(`/loyalty/store/adds/${pid}/${id}`)

export const deleteProductVar = (pid: number, id: number) => 
  http.delete<any, any>(`/loyalty/store/vars/${pid}/${id}`)


export const getListAdm = (params: any) => 
  http.get<any, any>(`/loyalty/store/admin${buildParams(params)}`)

export const getList = (params: any) => 
  http.get<any, any>(`/loyalty/store/list${buildParams(params)}`)

export const getStock = (id: number, page: number, limit: number) => 
  http.get<any, any>(`/loyalty/store/list/stock/${id}${buildParams({page, limit})}`)

export const addToStock = (pid: number, dto: any) => 
  http.post<any, any>(`/loyalty/store/list/stock/${pid}/add`)

export const writeFromStock = (pid: number, dto: any) => 
  http.post<any, any>(`/loyalty/store/list/stock/${pid}/write`, dto)

export const getProductById = (id: number) => 
  http.get<any, any>(`/loyalty/store/list/bi/${id}`)

export const getProductByName = (linkname: string) => 
  http.get<any, any>(`/loyalty/store/list/bl/${linkname}`)

export const createProduct = (dto: any) => 
  http.post<any, any>(`/loyalty/store/list`, dto)

export const updateProduct = (id: number, dto: any) => 
  http.put<any, any>(`/loyalty/store/list/${id}`, dto)

export const deleteProduct = (id: number) => 
  http.delete<any, any>(`/loyalty/store/list/${id}`)

export const getHypes = () => 
  http.get<any, any>(`/loyalty/store/hypes`)
